import React from "react";
import { motion } from "framer-motion";
import { ZOOD_MASCOT } from "@/lib/brand";

export default function MascotLoader({ message = "Loading…" }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center p-10 text-center" data-testid="mascot-loader">
      <motion.img
        src={ZOOD_MASCOT} alt="ZoodLeap mascot"
        className="w-28 drop-shadow-[0_0_16px_rgba(255,216,77,0.7)]"
        animate={{ y: [0, -12, 0] }}
        transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
      />
      <div className="mt-5 font-cursive text-2xl text-[#0D9488]">{message}</div>
      <div className="mt-3 h-2 w-40 overflow-hidden rounded-full bg-[#F2ECE1]">
        <motion.div className="h-full rounded-full bg-[#FF9E1B]"
          animate={{ x: ["-100%", "100%"] }}
          transition={{ duration: 1.1, repeat: Infinity, ease: "easeInOut" }}
          style={{ width: "60%" }} />
      </div>
    </div>
  );
}
